import styled from 'styled-components';

import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';

export const HrLegal = styled.hr`
  background: ${getColor('base900')};
  border: none;
  height: 1px;
  margin: 0;
  width: 100%;
  margin-top: ${getSpace('normal4')};
`;

export default HrLegal;
